import { render, staticRenderFns } from "./ChooseWholesalerView.vue?vue&type=template&id=76208fbc"
import script from "./ChooseWholesalerView.vue?vue&type=script&lang=ts"
export * from "./ChooseWholesalerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports